import { api } from "@/api/axios-instance";
import { apiResponseMiddleware } from "@/middleware/api-response";
import toast from "react-hot-toast";

import { SessionType } from "@/types/session";

const API_ENDPOINT = "/api/Authentication/User";

export const getSession = async (): Promise<SessionType | null> => {
  try {
    const response = await apiResponseMiddleware<SessionType>(
      api.get(API_ENDPOINT),
      () => { },
      {
        showToast: false
      }
    );

    console.log(response?.data?.activeRoleId);
    return response?.data ?? null;
  } catch {
    // نمایش پیام دلخواه برای خطای احراز هویت
    toast.error("احراز هویت ناموفق بود");
    return null;
  }
};